import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { CookieSensitiveContentWrapper } from "../cookiebar";
import { Block } from "../library/container";
export const IframeBlock = (props)=>/*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "block",
            children: /*#__PURE__*/ _jsx("div", {
                className: "container--mg align--center",
                children: /*#__PURE__*/ _jsx(CookieSensitiveContentWrapper, {
                    onChange: props.cookieUpdater,
                    children: /*#__PURE__*/ _jsx("iframe", {
                        width: "100%",
                        height: "420",
                        frameBorder: "0",
                        src: props.link,
                        title: "iframe"
                    })
                })
            })
        })
    });
